// All site content, sourced from the BuildiTech BIM Engineering Portfolio.

export const CONTACT = {
  email: 'sales@builditech.in',
  address: 'Kalyan Nagar, Bengaluru',
  website: 'www.builditech.in',
};

export const HERO_PHRASES = ['Fewer clashes.', 'Less rework.', 'Cleaner drawings.', 'Faster decisions.'];

// Illustrative labels for the hero model; replace with the real elements once confirmed.
export const HERO_PINS = [
  { x: 29, y: 60, kicker: 'Modeled', label: 'Process stack & supports' },
  { x: 52, y: 36, kicker: 'Coordinated', label: 'Pipe rack routing' },
  { x: 80, y: 62, kicker: 'Documented', label: 'Equipment building' },
];

export const TOOLS = [
  'Autodesk Revit', 'Navisworks', 'AutoCAD', 'Civil 3D', 'Autodesk ACC', 'BIM 360',
  'Dynamo', 'Power BI', 'BIMcollab', 'Solibri', 'Trimble Connect',
];

export const STATS = [
  { value: 48, text: 'of construction rework is linked to poor project data and miscommunication.', source: 'Autodesk + FMI' },
  { value: 35, text: 'of weekly hours go to non-optimal work: searching for data, resolving conflicts and rework.', source: 'PlanGrid + FMI' },
  { value: 98, text: 'of megaprojects overrun costs by more than 30%, and 77% are at least 40% late.', source: 'McKinsey' },
];

export const STATS_SOURCES =
  'Sources: Autodesk + FMI, Construction Disconnected; PlanGrid + FMI, Construction Disconnected; McKinsey, The Construction Productivity Imperative.';

export const WHY = [
  { title: 'Engineering-Led BIM', text: 'Practical, buildable models.' },
  { title: 'Early Clash Detection', text: 'Issues resolved before site.' },
  { title: 'Clear Documentation', text: 'Structured drawings and revisions.' },
  { title: 'Flexible Support', text: 'Scalable support for project teams.' },
];

export const SERVICES = [
  {
    id: 'modeling',
    title: 'BIM Modeling',
    tag: 'Arch · Str · MEP',
    image: '/images/c1.jpg',
    description:
      'Architecture, structure and MEP models that are practical and buildable, developed from your inputs and agreed standards.',
    deliverables: ['Architectural models', 'Structural models', 'MEP & fire systems', 'Equipment & plant layouts'],
    tools: ['Revit', 'AutoCAD', 'Civil 3D'],
  },
  {
    id: 'coordination',
    title: 'BIM Coordination',
    tag: 'Clash detection',
    image: '/images/c2.jpg',
    description:
      'Clash detection and model review so issues are resolved before they reach site. Federated models, issue tracking and decisions you can trace.',
    deliverables: ['Federated model review', 'Clash detection & reports', 'Coordination meetings', 'Issue tracking to closure'],
    tools: ['Navisworks', 'Autodesk ACC', 'BIMcollab', 'Solibri'],
  },
  {
    id: 'documentation',
    title: 'Construction Documentation',
    tag: 'Shop · As-built · BOQ',
    image: '/images/c6.jpg',
    description: 'Structured drawings and controlled revisions, taken straight from the coordinated model.',
    deliverables: ['Shop drawings', 'As-built drawings', 'BOQ support', 'Revision control'],
    tools: ['Revit', 'AutoCAD', 'Dynamo'],
  },
  {
    id: 'digital',
    title: 'Digital Project Support',
    tag: 'CDE · Issues · Data',
    image: '/images/c7.jpg',
    description:
      'One shared source for models, drawings and documents, so design, BIM and site teams work from the same information.',
    deliverables: ['CDE setup & management', 'Revision & issue control', 'Dashboards & reporting', 'Team collaboration'],
    tools: ['Autodesk ACC', 'BIM 360', 'Trimble Connect', 'Power BI'],
  },
  {
    id: 'scan',
    title: 'Scan to BIM',
    tag: 'Existing facilities',
    image: '/images/scan-b.jpg',
    description:
      '2D drawings and scan data turned into coordinated 3D Revit models for renovation, documentation and design updates.',
    deliverables: ['Point cloud to Revit', '2D to 3D conversion', 'As-built verification', 'Renovation support'],
    tools: ['Revit', 'Navisworks', 'AutoCAD'],
  },
];

export const LIFECYCLE = [
  { title: 'Input Review', text: 'SLDs, markups and clarifications are collected, logged and checked against the agreed standards before modeling starts.', output: 'Input register' },
  { title: 'BIM Modeling', text: 'Revit models are built or updated discipline by discipline, with QA/QC checks during production.', output: 'Discipline models' },
  { title: 'Coordination', text: 'Models are federated and reviewed together so every discipline works from the same information.', output: 'Federated model' },
  { title: 'Clash Resolution', text: 'Clashes are found in Navisworks and ACC, assigned, discussed in coordination meetings and tracked to closure.', output: 'Clash report + issue log' },
  { title: 'Documentation', text: 'Shop drawings, as-builts and BOQ support come out of the coordinated model with controlled revisions.', output: 'Drawing set + BOQ' },
  { title: 'QA/QC Delivery', text: 'An author–checker–approver review signs off every package before submission.', output: 'Approved submission' },
];

export const REVIEW_CYCLE = [
  { title: 'Inputs', text: 'SLDs / markups / clarifications' },
  { title: 'Model Update', text: 'Revit updates + QA/QC' },
  { title: 'Clash Check', text: 'Navisworks / ACC issues' },
  { title: 'Review', text: 'Meeting + decisions' },
  { title: 'Closure', text: 'Track to close' },
];

export const DELIVERY_MODEL = [
  { icon: 'MessagesSquare', where: 'Single point of contact', title: 'Client Interface', text: 'Technical coordination and communication with your project team.' },
  { icon: 'LayoutPanelLeft', where: 'India', title: 'Production Lead', text: 'BIM production planning and task control.' },
  { icon: 'ShieldCheck', where: 'Every submission', title: 'QA/QC Gate', text: 'Author–checker–approver review before anything leaves.' },
  { icon: 'Users', where: 'As you grow', title: 'Scalable Team', text: 'Pilot scope first, then a controlled expansion of the team.' },
];

export const ENGAGEMENT = [
  { title: 'Pilot package', text: 'to prove quality on a defined scope' },
  { title: 'Agreed standards', text: 'for naming, LOD and deliverables' },
  { title: 'Recurring coordination', text: 'on a fixed rhythm' },
  { title: 'Controlled scale-up', text: 'of the team' },
];

export const TECH_STACK = [
  { title: 'Modeling & Documentation', tools: ['Autodesk Revit', 'AutoCAD', 'Civil 3D'], benefits: ['Accurate models', 'Clear documentation', 'Design efficiency'] },
  { title: 'Automation & Reporting', tools: ['Dynamo', 'Excel', 'Power BI'], benefits: ['Time savings', 'Reduced errors', 'Better decisions'] },
  { title: 'Coordination & Collaboration', tools: ['Navisworks', 'BIMcollab', 'Solibri', 'Autodesk ACC', 'BIM 360', 'Trimble Connect'], benefits: ['Clash detection', 'Issue tracking', 'Secure collaboration'] },
];

export const COLLABORATION = [
  { title: 'Centralized Information', text: 'One common source for models, drawings and documents.' },
  { title: 'Revision & Issue Control', text: 'Track changes, approvals and open issues.' },
  { title: 'Team Collaboration', text: 'Better communication between design, BIM and site teams.' },
];

export const PROJECT_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'bld', label: 'Buildings & structures' },
  { id: 'elec', label: 'Electrical' },
  { id: 'util', label: 'Water & utilities' },
];

export const PROJECTS = [
  { title: 'Ancillary Buildings', category: 'bld', image: '/images/c1.jpg', wide: true },
  { title: 'Underground Services', category: 'util', image: '/images/c2.jpg' },
  { title: 'Electrical Equipment Yard', category: 'elec', image: '/images/c3.jpg' },
  { title: 'Underground Pump Room', category: 'util', image: '/images/c4.jpg' },
  { title: 'Connecting Bridge', category: 'bld', image: '/images/c5.jpg' },
  { title: 'DG & Transformer Yard', category: 'elec', image: '/images/c6.jpg', wide: true },
  { title: 'Cooling Towers', category: 'util', image: '/images/c8.jpg', wide: true },
  { title: 'Water Treatment Plant', category: 'util', image: '/images/c7.jpg', wide: true },
];

export const SCAN_PAIRS = {
  scan: { label: 'Site scan → Model', before: '/images/scan-a.jpg', after: '/images/scan-b.jpg', beforeLabel: 'Existing site', afterLabel: 'Revit model' },
  duct: { label: '2D data → 3D', before: '/images/duct-a.jpg', after: '/images/duct-b.jpg', beforeLabel: '2D / scan data', afterLabel: '3D Revit model' },
};

export const INDUSTRIES = ['Residential', 'Commercial', 'Industrial', 'Healthcare', 'Infrastructure', 'Education & Public'];

export const SNAPSHOT = [
  { title: 'Who we are', text: 'BIM engineering consultants supporting architects, engineers, contractors and project teams.' },
  { title: 'What we do', text: 'BIM modeling, coordination, documentation, Scan to BIM and digital project support.' },
  { title: 'Who we serve', text: 'Residential, commercial, industrial, healthcare, infrastructure and public-sector projects.' },
  { title: 'Value we bring', text: 'Better coordination, reduced rework, cleaner documentation and reliable project information.' },
];

export const MISSION =
  'To deliver reliable BIM and digital engineering support that improves coordination, accuracy, and project delivery.';
export const VISION =
  'To become a trusted BIM engineering partner for AEC teams working on complex building and infrastructure projects.';

export const TEAM = [
  { name: 'Kishor Mirji', role: 'B.Eng (Mechanical)' },
  { name: 'Saikiran Joshi', role: 'B.Eng (Mechanical)' },
];

export const TRAINING = [
  { title: 'Foundation', text: 'BIM concepts, construction basics and reading drawings.' },
  { title: 'Tool Training', text: 'Hands-on with Revit, Navisworks, AutoCAD, Dynamo and BIMcollab.' },
  { title: 'Project Simulation', text: 'Coordinate and deliver on real project scenarios.' },
];

export const TRAINING_PATH = ['Learn', 'Practice', 'Coordinate', 'Deliver'];

export const SERVICE_OPTIONS = ['BIM Modeling', 'Coordination', 'Documentation', 'Scan to BIM', 'Training'];
